"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasVariableWidthCappedLine = void 0;
const rc_js_util_1 = require("rc-js-util");
const context2d_render_util_1 = require("./context2d-render-util");
// FIXME this should probably take dom strings instead of packed colors
/**
 * @public
 */
class CanvasVariableWidthCappedLine {
    constructor(valueProvider) {
        this.valueProvider = valueProvider;
        this.p1 = new rc_js_util_1.Vec2.f64();
        this.p2 = new rc_js_util_1.Vec2.f64();
        this.p1Display = new rc_js_util_1.Vec2.f64();
        this.p2Display = new rc_js_util_1.Vec2.f64();
        this.l1Normal = new rc_js_util_1.Vec2.f64();
        this.l2Normal = new rc_js_util_1.Vec2.f64();
        this.cap = new rc_js_util_1.Vec2.f64();
    }
    /**
     * Begins a multi-segment line of variable width, call initialize with the first 2 points first.
     */
    beginLine(context, p1, p2) {
        this.valueProvider.setPosition(this.p1, p1.getX(), p1.getY());
        this.valueProvider.setPosition(this.p2, p2.getX(), p2.getY());
        this.p1Display.update(this.valueProvider.getSize(p1.getZ()), p1.getW());
        this.p2Display.update(this.valueProvider.getSize(p2.getZ()), p2.getW());
        context2d_render_util_1.Context2dRenderUtil.getLineNormal(this.p1, this.p2, this.l1Normal);
        context.lineWidth = 1;
        context.beginPath();
        context2d_render_util_1.Context2dRenderUtil.moveTo(context, this.p1, this.l1Normal, -this.p1Display[0]);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p1, this.l1Normal, this.p1Display[0]);
    }
    /**
     * This must stop 1 short of the end of the line (i.e. leave one point), this is because it would otherwise
     * attempt to compute a normal for a line that doesn't exist (to generate a non existent cap).
     */
    setMidPoint(context, x, y, size, packedColor) {
        this.endSegment(context, x, y, size, packedColor);
        context2d_render_util_1.Context2dRenderUtil.moveTo(context, this.p2, this.cap, -this.p2Display[0]);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p2, this.cap, this.p2Display[0]);
        this.performSwitcheroo();
    }
    /**
     * closes out the multi-segment line.
     */
    endLine(context, lastX, lastY, lastSize, lastPackedColor) {
        // finish off the second to last line
        this.endSegment(context, lastX, lastY, lastSize, lastPackedColor);
        // draw the final segment
        context2d_render_util_1.Context2dRenderUtil.moveTo(context, this.p2, this.cap, -this.p2Display[0]);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p2, this.cap, this.p2Display[0]);
        CanvasVariableWidthCappedLine.fillGap(context, this.p2Display[1]);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p1, this.l2Normal, this.p1Display[0]);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p1, this.l2Normal, -this.p1Display[0]);
        context2d_render_util_1.Context2dRenderUtil.closeMidSegment(context, this.p2Display[1]);
    }
    endSegment(context, x, y, size, packedColor) {
        // the color from the first point is used for the line color
        const lineColor = this.p1Display[1];
        CanvasVariableWidthCappedLine.fillGap(context, lineColor);
        // make p1 into the next point (p3), can do this in place as we don't need it anymore
        this.valueProvider.setPosition(this.p1, x, y);
        this.p1Display.update(this.valueProvider.getSize(size), packedColor);
        context2d_render_util_1.Context2dRenderUtil.getLineNormal(this.p2, this.p1, this.l2Normal);
        context2d_render_util_1.Context2dRenderUtil.normalizedAddition(this.l1Normal, this.l2Normal, this.cap);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p2, this.cap, this.p2Display[0]);
        context2d_render_util_1.Context2dRenderUtil.lineTo(context, this.p2, this.cap, -this.p2Display[0]);
        context2d_render_util_1.Context2dRenderUtil.closeMidSegment(context, lineColor);
    }
    performSwitcheroo() {
        // retain the objects
        const pTmp = this.p2;
        this.p2 = this.p1;
        this.p1 = pTmp;
        const dTmp = this.p2Display;
        this.p2Display = this.p1Display;
        this.p1Display = dTmp;
        const lTmp = this.l1Normal;
        this.l1Normal = this.l2Normal;
        this.l2Normal = lTmp;
    }
    static fillGap(context, lineColor) {
        // depending on the layout there may be a aliasing gap, fill it with a 1 px line...
        context.strokeStyle = rc_js_util_1.RgbaColorPacker.makeDomColorString(lineColor);
        context.stroke();
    }
}
exports.CanvasVariableWidthCappedLine = CanvasVariableWidthCappedLine;
//# sourceMappingURL=canvas-variable-width-capped-line.js.map